import React from 'react';
import { Helmet } from 'react-helmet';
import Navbar from './Navbar'; // Assuming you have a Navbar component
import Footer from './Footer'; // Assuming you have a Footer component
import './layout.css'; // The CSS containing the flexbox styles
import { Analytics } from "@vercel/analytics/react"

const Layout = ({ children }) => {
  return (
    <>
      <Helmet>
        <link rel="icon" href="/imag/bubble-image.png" type="image/png" />
      </Helmet>
      <Navbar />
      <main className="wrapper">
        <div className="content">
          {children} {/* Main content of the page */}
          <Analytics />
        </div>
        <Footer /> {/* Footer is always included at the bottom */}
      </main>
    </>
  );
};

export default Layout;
